import React from 'react';
import { motion } from 'framer-motion';
const ProblemSolutionSection = () => {
  return <section id="sobre" className="relative py-12 md:py-32 px-4 bg-gradient-to-b from-black via-luxury-purple/5 to-black">
      <div className="max-w-7xl mx-auto">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="grid md:grid-cols-2 gap-8 items-center">
          {/* Left Column - Problem */}
          <div>
            <h2 className="text-4xl md:text-5xl font-bold mb-6 text-white">
              Cansado de conexões vazias?
            </h2>
            <p className="text-lg text-white/70 leading-relaxed">
              Nos aplicativos tradicionais, você encontra superficialidade, 
              perfis falsos e pessoas que não sabem o que querem. 
              Tempo e energia desperdiçados em conversas que não levam a lugar nenhum.
            </p>
          </div>

          {/* Right Column - Solution */}
          <div>
            <h2 className="text-4xl md:text-5xl font-bold mb-6 bg-gradient-to-r from-luxury-pink via-luxury-mediumPink to-luxury-lightPurple bg-clip-text text-transparent">
              Clareza desde o primeiro contato
            </h2>
            <p className="text-lg text-white/70 leading-relaxed">
              No Interlaced, cada perfil é verificado. São pessoas reais, que sabem o que 
              querem e o que podem oferecer. Cada troca de mensagens tem propósito, respeito 
              e discrição. Seu tempo é valioso demais para ser desperdiçado.
            </p>
            <p className="text-lg text-luxury-pinkBright font-semibold mt-6">
              Sugar Daddies, Sugar Mommies e Sugar Babies que valorizam transparência.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
};
export default ProblemSolutionSection;